/* ==========================================================================
   ATN CyberMall Landing Page V1.0 — Section 01: CyberMall Hero

   1. Reveal-on-scroll entrance animation (IntersectionObserver).
   2. Optional analytics for the two CTAs and linked statistics.
   3. Optional video popup on the secondary CTA (native <dialog>).
   ========================================================================== */

(function () {
  'use strict';

  var LOCK_CLASS = 'atn-cmhero-lock';

  function deviceType() {
    var w = window.innerWidth;
    if (w <= 749) return 'mobile';
    if (w <= 1100) return 'tablet';
    return 'desktop';
  }

  function sectionIdFrom(el) {
    var wrapper = el.closest('[id^="shopify-section-"]');
    return wrapper ? wrapper.id.replace('shopify-section-', '') : '';
  }

  function send(root, eventName, params) {
    if (root.dataset.analytics !== 'true' || !eventName) return;

    var payload = Object.assign(
      {
        device_type: deviceType(),
        section_id: sectionIdFrom(root),
        current_page: window.location.pathname
      },
      params || {}
    );

    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push(Object.assign({ event: eventName }, payload));
    }
    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, payload);
    }
  }

  function reveal(root) {
    if (!root.classList.contains('atn-cmhero--animate')) return;

    var prefersReduced =
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (prefersReduced || !('IntersectionObserver' in window)) {
      root.classList.add('is-visible');
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    observer.observe(root);
  }

  function bindAnalytics(root) {
    if (root.dataset.analytics !== 'true') return;

    root.addEventListener('click', function (event) {
      var cta = event.target.closest('[data-atn-cmhero-event]');
      if (cta) {
        var isVideo = cta.hasAttribute('data-atn-cmhero-video-open');
        send(root, cta.dataset.atnCmheroEvent, {
          cta_label: (cta.textContent || '').trim(),
          destination_url: cta.getAttribute('href') || '',
          interaction_method: isVideo ? 'video_popup' : 'click'
        });
        return;
      }

      var stat = event.target.closest('[data-atn-cmhero-stat]');
      if (stat) {
        send(root, 'cybermall_hero_stat_interaction', {
          statistic_name: stat.dataset.atnCmheroStat || '',
          destination_url: stat.getAttribute('href') || '',
          interaction_method: 'click'
        });
      }
    });
  }

  function bindVideo(root) {
    var dialog = root.querySelector('[data-atn-cmhero-modal]');
    var trigger = root.querySelector('[data-atn-cmhero-video-open]');
    if (!dialog || !trigger) return;

    var video = dialog.querySelector('video');
    var autoplay = dialog.dataset.autoplay === 'true';
    var supportsModal = typeof dialog.showModal === 'function';

    function stopVideo() {
      if (!video) return;
      video.pause();
      try {
        video.currentTime = 0;
      } catch (e) {
        /* Ignore when metadata is not loaded yet */
      }
    }

    function afterClose() {
      stopVideo();
      document.documentElement.classList.remove(LOCK_CLASS);
    }

    function open() {
      if (supportsModal) {
        if (!dialog.open) dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
        dialog.classList.add('atn-cmhero-modal--fallback');
      }
      document.documentElement.classList.add(LOCK_CLASS);

      if (video && autoplay) {
        var playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function () {
            /* Browser blocked autoplay — controls stay available */
          });
        }
      }
    }

    function close() {
      if (supportsModal) {
        /* The native "close" event runs afterClose */
        if (dialog.open) dialog.close();
      } else {
        dialog.removeAttribute('open');
        dialog.classList.remove('atn-cmhero-modal--fallback');
        afterClose();
        trigger.focus();
      }
    }

    trigger.addEventListener('click', function (event) {
      event.preventDefault();
      open();
    });

    dialog.addEventListener('click', function (event) {
      /* Click on the backdrop targets the dialog itself */
      if (
        event.target === dialog ||
        event.target.closest('[data-atn-cmhero-video-close]')
      ) {
        close();
      }
    });

    dialog.addEventListener('close', afterClose);

    if (!supportsModal) {
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && dialog.hasAttribute('open')) close();
      });
    }
  }

  function bind(root) {
    if (root.dataset.atnCmheroBound === 'true') return;
    root.dataset.atnCmheroBound = 'true';
    reveal(root);
    bindAnalytics(root);
    bindVideo(root);
  }

  function init(scope) {
    (scope || document)
      .querySelectorAll('[data-atn-cmhero-root]')
      .forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  /* Theme editor: release scroll lock if the section reloads while open */
  document.addEventListener('shopify:section:unload', function () {
    document.documentElement.classList.remove(LOCK_CLASS);
  });
})();